import { differenceInDays } from 'date-fns';
import { DateRangePicker } from '@/components/ui/date-range-picker';
import { UserFilterSelect } from './filters/UserFilterSelect';
import { ComparisonToggle } from './filters/ComparisonToggle';
import { resolvePresetRange } from '@/lib/analytics/ranges';
import type { AnalyticsFilters as Filters } from '@/hooks/useAnalyticsFilters';

interface AnalyticsFiltersProps {
  filters: Filters;
  setFilters: (patch: Partial<Filters>) => void;
  isAdmin: boolean;
  members: { user_id: string; display_name: string }[];
  currentUserId: string;
}

export function AnalyticsFilters({
  filters,
  setFilters,
  isAdmin,
  members,
  currentUserId,
}: AnalyticsFiltersProps) {
  const range = resolvePresetRange(filters.range, {
    from: filters.from ? new Date(filters.from) : undefined,
    to: filters.to ? new Date(filters.to) : undefined,
  });
  const rangeLengthDays = differenceInDays(range.to, range.from);
  const compareDisabled =
    filters.range === 'custom' && (rangeLengthDays < 3 || rangeLengthDays > 730);

  return (
    <div className="flex flex-wrap items-center gap-2 p-4 border-b sticky top-0 bg-background z-10">
      <DateRangePicker
        value={{ from: range.from, to: range.to }}
        onChange={(v) => {
          if (v?.from && v?.to) {
            setFilters({
              range: 'custom',
              from: v.from.toISOString(),
              to: v.to.toISOString(),
            });
          }
        }}
        onPreset={(preset) => {
          setFilters({ range: preset, from: undefined, to: undefined });
        }}
      />
      {isAdmin && (
        <UserFilterSelect
          value={filters.user}
          onChange={(v) => setFilters({ user: v })}
          members={members}
          currentUserId={currentUserId}
        />
      )}
      <ComparisonToggle
        value={filters.compare}
        onChange={(v) => setFilters({ compare: v })}
        disabled={compareDisabled}
      />
    </div>
  );
}
